// @ts-nocheck
// import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge"; // Starter Custom Code
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendProductRecommendationTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendProductRecommendationTracking";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
// import ProductAddToListLink, {
//     ProductAddToListLinkStyles,
// } from "@insite/content-library/Components/ProductAddToListLink"; // Foundation
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
// import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription"; // Starter Custom Code
// import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage"; // Starter Custom Code
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Starter Custom Code
// import ProductPrice from "@insite/content-library/Components/ProductPrice"; // Starter Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
// import Badge from "@insite/mobius/Badge"; // Starter Custom Code
import { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import Badge from "@store/MobiusOverrides/Badge/Badge";
import { ProductAddToCartButtonStyles } from "@store/Overrides/Components/ProductAddToCartButton";
// import ProductAttributes, { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes"; // Foundation
import {
    ProductAvailabilityStyles,
    useShowProductAvailability,
} from "@store/Overrides/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { productCardProps } from "@store/Themes/common/props/productCard";
import useOverlayBadge from "@toolkit/Modules/client-framework/Common/Hooks/useOverlayBadge";
/* Starter Custom Code - End */

// Foundation --->
import {
    useIsHideSignInToSeePriceButton,
    useIsSignedInAndhasToBeSignedIn,
} from "@store/Framework/Store/Context/ContextHooks";
import ProductAttributes, { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes";
import {
    actionsCardStyles,
    productCardInformationStyles,
    productListProps,
} from "@store/Themes/common/props/product";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@store/Overrides/Components/ProductAddToListLink";
// <--- Foundation

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
    // Starter Custom Code
    showInventoryAvailability: getSettingsCollection(state).productSettings.showInventoryAvailability,
});

const mapDispatchToProps = {
    updateProductInfo,
    sendProductRecommendationTracking,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    recommendationId?: number;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    showImageBadges?: boolean;
    maximumNumberOfImageBadges?: number;
    showTextBadges?: boolean;
    maximumNumberOfTextBadges?: number;
    extendedStyles?: ProductCarouselProductStyles;
    // Starter Custom Code
    showAttributes: boolean;
    showAvailability: boolean;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductCarouselProductStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: GridContainerProps;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: GridItemProps;
    productAddToCartButtonStyles?: ProductAddToCartButtonStyles; // Starter Custom Code
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    // Starter Custom Code
    attributesWrapper?: InjectableCss;
    attributes?: ProductAttributesStyles;
    availability?: ProductAvailabilityStyles;
    productActionsWrapper?: InjectableCss;
    productPrice?: ProductPriceStyles;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
    productAddToListWrapper?: InjectableCss;
    // Foundation
    imageWrapper?: InjectableCss;
    productInformationWrapper?: InjectableCss;
    informationItem?: InjectableCss;
    brandWrapper?: InjectableCss;
    actionWrapper?: InjectableCss;
    price?: ProductPriceStyles;
    actionWrapperLeftColumn?: InjectableCss;
    actionWrapperRightColumn?: InjectableCss;
    actionButtons?: ButtonPresentationProps;
}

export const productCarouselProductStyles: ProductCarouselProductStyles = {
    productImageStyles: productCardProps.image,
    productBrandStyles: productCardProps.brand,
    productDescriptionStyles: {
        ...productCardProps.description,
        wrapper: {
            ...productCardProps.description?.wrapper,
            forwardAs: "h3",
        },
    },
    attributesWrapper: productCardProps.spacingWrapper,
    productPartNumbersStyles: productCardProps.partNumbers,
    attributes: productCardProps.attributes,
    availability: productCardProps.availability,
    productActionsWrapper: productCardProps.actionsWrapper,
    productPriceWrapper: productCardProps.spacingWrapper,
    productPrice: productCardProps.price,
    productQuantityBreakPricingStyles: productCardProps.quantityBreakPricing,
    addToCartOptionsAndButton: productCardProps.addToCartOptionsAndButton,
    productAddToListWrapper: productCardProps.addToListWrapper,
    productAddToListLinkStyles: productCardProps.addToListLink,
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
    // Foundation -->
    imageWrapper: productListProps.imageWrapper,
    productInformationWrapper: productCardInformationStyles.productInformationWrapper,
    informationItem: productCardInformationStyles.informationItem,
    brandWrapper: productCardInformationStyles.brandWrapper,
    actionWrapper: actionsCardStyles.wrapper,
    price: actionsCardStyles.price,
    actionWrapperLeftColumn: actionsCardStyles.leftColumn,
    actionWrapperRightColumn: actionsCardStyles.rightColumn,
    actionButtons: actionsCardStyles.addToCartButton,
    // <-- Foundation
};

const ProductCarouselProduct = ({
    carouselId,
    product,
    showImage,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    showAddToList,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    updateProductInfo,
    extendedStyles,
    productInfo,
    recommendationId,
    sendProductRecommendationTracking,
    // Starter Custom Code
    showAttributes,
    showAvailability: baseShowAvailability,
    showInventoryAvailability,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productCarouselProductStyles, extendedStyles));
    const showAvailability = useShowProductAvailability() && baseShowAvailability;
    // Foundation ->
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const isHideSignInToSeePriceButton = useIsHideSignInToSeePriceButton();
    // <- Foundation

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    const trackProductRecommendation = (isNewPageWasOpen: boolean) => {
        if (recommendationId) {
            sendProductRecommendationTracking({ recommendationId, isNewPageWasOpen });
        }
    };

    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    const canAddToList = showAddToList && product.canAddToWishlist; // Starter Custom Code

    // Foundation --->
    const buttonStyle: ButtonPresentationProps = isSignedInAndhasToBeSignedIn
        ? (styles.actionButtons as ButtonPresentationProps)
        : {
              ...styles.actionButtons,
              typographyProps: {
                  css: css`
                      white-space: normal;
                  `,
              },
          };
    // <--- Foundation

    return (
        <>
            <ProductContext.Provider value={productContext}>
                {showImage && !showOverlayBadge && (
                    <ProductImage
                        product={productContext}
                        onClick={() => trackProductRecommendation(true)}
                        extendedStyles={styles.productImageStyles}
                        size="medium" // Starter Custom Code
                    />
                )}
                {showImage && showOverlayBadge && overlayBadge && (
                    <StyledWrapper
                        {...styles.badgeAreaWrapper}
                        ref={badgeAreaWrapperRef}
                        data-test-selector="productCarouselBadge"
                    >
                        <ProductImage
                            extendedStyles={styles.productImageStyles}
                            product={productContext}
                            size="medium" // Starter Custom Code
                        />
                        <StyledWrapper {...overlayBadgeWrapperStyles} onClick={overlayBadgeWrapperClickHandler}>
                            <Badge
                                type={overlayBadge.badgeType}
                                value={
                                    overlayBadge.badgeType === "Image"
                                        ? overlayBadge.largeImageBadgePath
                                        : overlayBadge.displayText
                                }
                                badgeTextColor={overlayBadge.textColorHexCode}
                                badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                                badgeTextRounding={overlayBadge.badgeStyle === "Round"} // Starter Custom Code
                                imageAltText={overlayBadge.imageAltText ? overlayBadge.imageAltText : overlayBadge.name}
                                textBadgeCss={styles.badgeText}
                                imageBadgeProps={styles.badgeImageProps}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {/* Foundation ---> */}
                <StyledWrapper {...styles.productInformationWrapper}>
                    <StyledWrapper {...styles.brandWrapper}>
                        {showBrand && product.brand && (
                            /* Starter Custom Code - Start */
                            <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                            /* Starter Custom Code - End */
                        )}
                    </StyledWrapper>

                    {showTitle && (
                        <StyledWrapper {...styles.informationItem}>
                            <ProductDescription
                                product={productContext}
                                onClick={() => trackProductRecommendation(true)}
                                extendedStyles={styles.productDescriptionStyles}
                            />
                        </StyledWrapper>
                    )}
                    {/* Starter Custom Code - Start */}
                    {showPartNumbers || showAttributes ? (
                        <StyledWrapper {...styles.attributesWrapper}>
                            {showPartNumbers && (
                                <ProductPartNumbers
                                    productNumber={product.productNumber}
                                    customerProductNumber={product.customerProductNumber}
                                    manufacturerItem={product.manufacturerItem}
                                    showCustomerName={false}
                                    showManufacturerItem={false}
                                    extendedStyles={styles.productPartNumbersStyles}
                                />
                            )}
                            {showAttributes ? (
                                <ProductAttributes
                                    maximumNumberAttributeTypes={3}
                                    extendedStyles={styles.attributes}
                                    fallbackOnNormalAttributeType={false}
                                />
                            ) : null}
                        </StyledWrapper>
                    ) : null}
                    {showInventoryAvailability && showAvailability ? (
                        <ProductContextAvailability extendedStyles={styles.availability} />
                    ) : null}
                    {/* Starter Custom Code - End */}
                    {showTextBadges && textBadges && (
                        <ProductTextBadges badgeList={textBadges} maxBadges={maximumNumberOfTextBadges ?? 4} />
                    )}
                    {/* <--- Foundation */}
                </StyledWrapper>
                {/* Foundation --> */}
                {isHideSignInToSeePriceButton && !isSignedInAndhasToBeSignedIn ? null : (
                    <StyledWrapper {...styles.actionWrapper}>
                        {showImageBadges && imageBadges && (
                            <ProductImageBadges badgeList={imageBadges} maxBadges={maximumNumberOfImageBadges ?? 4} />
                        )}
                        {isSignedInAndhasToBeSignedIn && (
                            <StyledWrapper {...styles.actionWrapperLeftColumn}>
                                {showPrice && (
                                    <>
                                        <ProductPrice
                                            showLabel={false}
                                            product={productContext}
                                            extendedStyles={styles.price}
                                        />
                                        {product.unitOfMeasures && (
                                            <ProductUnitOfMeasureSelect
                                                labelOverride=""
                                                extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                                id={`${carouselId}-uom`}
                                            />
                                        )}
                                        <ProductQuantityBreakPricing
                                            extendedStyles={styles.productQuantityBreakPricingStyles}
                                        />
                                    </>
                                )}
                            </StyledWrapper>
                        )}
                        <StyledWrapper {...styles.actionWrapperRightColumn}>
                            {showAddToCart && (
                                <ProductAddToCartButton
                                    data-test-selector="addToCartBtn"
                                    extendedStyles={buttonStyle}
                                />
                            )}
                            {canAddToList /* Starter Custom Code */ && (
                                <StyledWrapper {...styles.productAddToListWrapper /* Starter Custom Code */}>
                                    <ProductAddToListLink
                                        data-test-selector="addToListLink"
                                        extendedStyles={styles.productAddToListLinkStyles}
                                    />
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {/* <--- Foundation */}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarouselProduct);
